var ishttps = 'https:' == document.location.protocol ? true : false

//正式 https://aws.globalMacecoin.net  测试：http://bt-admin.recallg.net
export const postUrl = ishttps ? 'https://aws.bitfuy.com' : "https://aws.bitfuy.com"